import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { Button, Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import { textFormat } from "utils/Utils";
import FileUploadDisbursal from "components/FileUpload/FileUploadDisbursal";
import ToastModal from "views/components/ToastModal";
import { parseAndSetFlag } from "utils/Utils";
import { GenderListData } from "assets/properties/properties";
import { parseDate } from "utils/Utils";
import { setyear } from "assets/properties/properties";
import { removeSpecialCharFileName } from "utils/Utils";
import { loanApplicationStatus } from "assets/properties/properties";
import { calculateAge } from "utils/Utils";
import { headerLabel } from "assets/properties/properties";
import CustomDateField from "components/CustomDateSelector/CustomDateField";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "views/components/ConfirmationModal";

const Nominee = ({
  setNext,
  setBack,
  loanApplicationId,
  editable,
  status,
  classes,
  mobileNum,
  featureFlags,
  existingLoanData,
}) => {
  const navigate = useNavigate();
  const { applicantDetails } = useSelector(
    (state) => state.loanDetail.applicantLoanDetail
  );
  const [fileUpload, setFileUpload] = useState("");
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [borrower, setBorrower] = useState("");
  const [borrowState, setBorrowState] = useState(false);
  const [nomineeName, setNomineeName] = useState("");
  const [nomineeNameState, setNomineeNameState] = useState(false);
  const [nomineeAddress, setNomineeAddress] = useState("");
  const [nomineeAddressState, setNomineeAddressState] = useState(false);
  const [nomineeAge, setNomineeAge] = useState("");
  const [nomineeAgeState, setNomineeAgeState] = useState(false);
  const [dateOfBirth, setDateOfBirth] = useState(null);
  const [gender, setGender] = useState("Male");

  const [applicantRecord, setApplicantRecord] = useState(
    applicantDetails?.addresses?.[0]
  );
  const [mobileNumber, setMobileNumber] = useState("");
  const [fileName, setFileName] = useState("");
  const [mobileNumberState, setMobileNumberState] = useState(false);
  const [checkbox, setCheckbox] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [getImage, setGetImage] = useState(false);
  const [disableNext, setDisableNext] = useState("");
  const [tableColumns, setTableColumns] = useState([
    { id: "account", label: "loan Account" },
    { id: "id", label: "Customer Id" },
    { id: "name", label: "Customer Name" },
    { id: "due", label: "Due Payment" },
    { id: "total", label: "Principal" },
    { id: "status", label: "Status" },
  ]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const outletData = featureFlags;
  const GenderList = outletData?.genderList
    ? JSON.parse(outletData?.genderList)
    : GenderListData;
  const NomineeFieldShow = parseAndSetFlag(outletData?.showNomineeFields);
  const enabledV2InprocessTab = parseAndSetFlag(outletData?.enabledV2InprocessTab);
  const maxAgeForDateOfBirth = Number(outletData?.maxAgeForDateOfBirth) || 0;
  const nomineeMobileNumberNonMandatoryFlag = parseAndSetFlag(
    outletData?.nomineeMobileNumberNonMandatoryFlag
  );
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  let fileUploadComponent = useRef();
  const [borrowList, setBorrowList] = useState([]);
  useEffect(() => {
    GetnomieeDetails();
    if (status === "INPROCESS" || editable) {
      GetRelationship();
    }
  }, []);
  useEffect(() => {
    if (fileUpload) {
      uploadDocument();
    }
  }, [fileUpload]);

  const uploadDocument = async () => {
    setCallInProgress(true);
    const formData = new FormData();
    const fileName = removeSpecialCharFileName(fileUpload.name);
    formData.append("file", fileUpload, fileName);
    const result = await apiHandler({
      url: endpoint.FILE_UPLOAD,
      method: "POST",
      authToken: authToken,
      data: formData,
    });
    setCallInProgress(false);
    const uploadedPath = result.data;
    setFileName(uploadedPath.name);
  };

  const GetRelationship = async () => {
    const res = await apiHandler({
      url: endpoint.RELATIONSHIP_FINDALL,
      method: "GET",
      authToken: authToken,
    });
    if (res?.data?.length) {
      setBorrowList(res?.data);
    }
  };

  const GetLoanDetails = async (e) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.FIND_LOAN_SATUS + "?phoneNumber=" + e,
      method: "GET",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.length) {
      parseIndicatorData(res.data);
    } else {
      setSelectedTableData([]);
    }
  };
  const parseIndicatorData = (data) => {
    let reportData = [];
    data &&
      data?.forEach((InProcessApplication, index) => {
        let row = {
          account: InProcessApplication.loanAccount,
          id: InProcessApplication.customerId,
          name: InProcessApplication.customerName,
          due: InProcessApplication.loanDetails?.totaloverdue,
          total: InProcessApplication.loanDetails?.sanctionedLoanAmount,
          status: InProcessApplication.status,
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const GetExistingNomineeDetails = async () => {
    const res = await apiHandler({
      url: endpoint.SEARCH_PROFILE + mobileNum,
      method: "GET",
      authToken: authToken,
    });
    if (res?.data?.[0]?.nomineeDetails?.[0]?.name !== null) {
      updateData(res?.data?.[0]?.nomineeDetails?.[0]);
    }
  };

  const GetnomieeDetails = async () => {
    // NOMINEE_GETDATA
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.NOMINEE_GETDATA + loanApplicationId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (
      result?.data?.error_code ||
      result?.data === "" ||
      result?.data?.name === ""
    ) {
      if (!existingLoanData?.nomineeDetails?.name) {
        GetExistingNomineeDetails();
      } else {
        updateData(existingLoanData?.nomineeDetails);
      }
    } else {
      updateData(result?.data);
    }
  };

  const updateData = (nomineeData) => {
    setNomineeName(nomineeData?.name);
    setBorrower(textFormat(nomineeData?.relationship));
    setNomineeAddress(nomineeData?.address);
    setNomineeAge(nomineeData?.age);
    setMobileNumber(nomineeData?.mobileNumber?.trim());
    setFileName(nomineeData?.attachment);
    setDateOfBirth(nomineeData?.dob);
    setGender(nomineeData?.gender);
    setGetImage(true);
    setFileUpload("");
    if (nomineeData?.mobileNumber?.trim()) {
      GetLoanDetails(nomineeData?.mobileNumber?.trim());
    }
  };
  const isValidated = () => {
    let isValid = true;
    const minimumDate = setyear(maxAgeForDateOfBirth);
    const dob = new Date(dateOfBirth);
    if (nomineeName === "" || typeof nomineeName === "undefined") {
      setNomineeNameState(true);
      isValid = false;
    } else {
      setNomineeNameState(false);
    }
    if (nomineeAddress === "" || typeof nomineeAddress === "undefined") {
      setNomineeAddressState(true);
      isValid = false;
    } else {
      setNomineeAddressState(false);
    }
    if (borrower === "" || typeof borrower === "undefined") {
      setBorrowState(true);
      isValid = false;
    } else {
      setBorrowState(false);
    }
    // Check mobile number only if nomineeMobileNumberNonMandatoryFlag is false
    if (!nomineeMobileNumberNonMandatoryFlag) {
      if (
        mobileNumber === "" ||
        typeof mobileNumber === "undefined" ||
        mobileNumber.length !== 10
      ) {
        setMobileNumberState(true);
        isValid = false;
      } else {
        setMobileNumberState(false);
      }
    } else {
      setMobileNumberState(false); // If flag is true, skip mobile number validation
    }
    if (Number(nomineeAge) > maxAgeForDateOfBirth || Number(nomineeAge) < 18) {
      isValid = false;
    }
    if (
      (dateOfBirth === "" ||
        typeof dateOfBirth === "undefined" ||
        dateOfBirth === null ||
        parseDate(dateOfBirth) === "NaN-NaN-NaN" ||
        dob < minimumDate) &&
      NomineeFieldShow
    ) {
      isValid = false;
    }
    return isValid;
  };
  const handlecreateuserSubmit = async (event) => {
    event?.stopPropagation();
    event?.preventDefault();

    if (!isValidated()) {
      const minimumDate = setyear(maxAgeForDateOfBirth);
      const dob = new Date(dateOfBirth);

      if (dob < minimumDate && NomineeFieldShow) {
        toastUpdate(
          "Information",
          `Date of birth cannot be less than ${maxAgeForDateOfBirth} years`,
          true
        );
        return;
      }

      if (
        Number(nomineeAge) > maxAgeForDateOfBirth ||
        Number(nomineeAge) < 18
      ) {
        toastUpdate(
          "Error",
          `Date of birth cannot be more than ${maxAgeForDateOfBirth} years and less than 18 years`,
          true
        );
        return;
      }

      if (
        (!dateOfBirth ||
          parseDate(dateOfBirth) === "NaN-NaN-NaN") &&
        NomineeFieldShow
      ) {
        toastUpdate("Error", "Please fill the date of birth", true);
      }

      return;
    }
    if (enabledV2InprocessTab) {
      setConfirmationModalHeader("Confirm Submission");
      setConfirmationModalMsg(
        "Are you sure you want to submit the applicant?"
      );
      setConfirmationModal(true);
      return;
    }
    await submitNomineeDetails();
  };
  // cancel button function
  const handlecanceluser = () => {
    setBack();
    //props.history.go(-1);
  };
  const checkedAddress = (event) => {
    if (event.target.checked) {
      setNomineeAddress(
        applicantRecord.houseNumber +
          ", " +
          applicantRecord.street +
          ", " +
          applicantRecord.locality +
          ", " +
          applicantRecord.postOffice +
          ", " +
          applicantRecord.villageTownCity +
          ", " +
          applicantRecord.state +
          ", " +
          applicantRecord.district +
          ", " +
          applicantRecord.pincode
      );
    } else {
      setNomineeAddress("");
    }
  };
  const handlenext = () => {
    setNext();
  };
  const back = () => {
    setBack();
  };

  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setNomineeAge(e);
    }
  };
  const handleMobileNumber = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e === "" || regex.test(e)) {
      setMobileNumber(e);
    }
  };
  const blurMobileNumber = (e) => {
    if (e === mobileNum) {
      toastUpdate("Error", "Nominee is an exisiting customer", true);
      setDisableNext(true);
      GetLoanDetails(e);
    } else {
      setDisableNext(false);
      GetLoanDetails(e);
    }
  };
  useEffect(() => {
    const minimumDate = setyear(maxAgeForDateOfBirth);
    const dob = new Date(dateOfBirth);
    if (dob < minimumDate && NomineeFieldShow) {
      toastUpdate(
        "Information",
        `Date of birth can not be less than ${maxAgeForDateOfBirth} years`,
        true
      );
    }
  }, [dateOfBirth]);
  const handleDateChange = (date) => {
    setDateOfBirth(date);
    setNomineeAge(calculateAge(date));
  };
 const handleNegativeResponse = () => {
  setConfirmationModal(false);
};

const handlePositiveResponse = () => {
  submitNomineeDetails();
};
const submitNomineeDetails = async () => {
  setConfirmationModal(false);
  setCallInProgress(true);

  try {
    const res = await apiHandler({
      url: endpoint.NOMINEE_ADD,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
        name: nomineeName || null,
        address: nomineeAddress || null,
        relationship: borrower || null,
        age: nomineeAge || null,
        mobileNumber: mobileNumber?.trim(),
        attachment: fileName,
        dob:
          parseDate(dateOfBirth) === "NaN-NaN-NaN"
            ? ""
            : parseDate(dateOfBirth),
        gender: gender || "Male",
      },
    });

    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    }

    if (enabledV2InprocessTab) {
      navigate("/loanservice/inProcess", {
        state: { from: "" },
      });
      return;
    }

    toastUpdate("Success", "Create Nominee successfully", true);
    setNext();
  } catch (error) {
    toastUpdate(
      "Error",
      "Unable to submit nominee details. Please try again.",
      true
    );
  } finally {
    setCallInProgress(false);
  }
};
  return (
    // <div>
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={headerLabel?.nominee}
          subLabel={`${headerLabel.loanAppId} ${loanApplicationId}`}
          onlyLabel
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Nominee Name"
              required
              error={nomineeNameState}
              value={nomineeName || ""}
              setState={setNomineeName}
              setError={setNomineeNameState}
              disabled={!editable}
              id="nominee_name"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Nominee Address"
              required
              error={nomineeAddressState}
              value={nomineeAddress || ""}
              setState={setNomineeAddress}
              setError={setNomineeAddressState}
              disabled={!editable}
              id="nomineee_address"
            />
            <label style={{ display: "flex" }}>
              <input
                style={{ marginTop: 2 }}
                type="checkbox"
                value={checkbox}
                onChange={(e) => checkedAddress(e)}
                disabled={!editable}
              />{" "}
              same as customer address
            </label>
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            {!editable ? (
              <CustomeTextField
                label="Relationship With Borrower"
                required
                value={borrower?.toUpperCase()}
                disabled={true}
                id="relationship_with_borrower"
              />
            ) : (
              <CustomeSelectNew
                label="Relationship With Borrower*"
                error={borrowState}
                value={borrower?.toUpperCase()}
                setState={setBorrower}
                data={borrowList}
                setError={setBorrowState}
                disabled={!editable}
                type="relationshipname"
                id="relationship_with_borrower"
              />
            )}
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeSelectNew
              label="Gender*"
              id="gender"
              value={gender || GenderList[0]}
              setState={setGender}
              data={GenderList}
              disabled={!editable}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
               <CustomDateField
                 onChange={handleDateChange}
                 value={dateOfBirth ? dateOfBirth : null}
                 label="Date Of Birth(DD/MM/YYYY)"
                 disabled= {!editable}
                 minDate={setyear(maxAgeForDateOfBirth)}
                 maxDate={setyear(18)}
               />
            </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Nominee Age(Year)"
              required
              error={nomineeAgeState}
              value={nomineeAge || ""}
              setState={handleChange}
              maxLength="2"
              setError={setNomineeAgeState}
              disabled={true}
              id="nominee_age"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Nominee Contact Number"
              required
              id="sourcer_content"
              error={mobileNumberState}
              value={mobileNumber?.trim() || ""}
              setState={handleMobileNumber}
              maxLength="10"
              setError={setMobileNumberState}
              setBlur={blurMobileNumber}
              disabled={!editable}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={classes.fieldContaienr}
            style={{ width: "100%", textAlign: "left", maxWidth: "100%" }}
          >
            {editable && (
              <FileUploadDisbursal
                addButtonProps={{
                  color: "info",
                  round: false,
                }}
                changeButtonProps={{
                  color: "info",
                  round: false,
                }}
                removeButtonProps={{
                  color: "danger",
                  round: false,
                }}
                removeFile={() => {
                  setFileUpload("");
                  setFileName("");
                }}
                sendFile={(file) => {
                  setFileUpload(file);
                  setFileName("");
                }}
                ref={fileUploadComponent}
              />
            )}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={classes.fieldContaienr}
            style={{ width: "100%", textAlign: "left", maxWidth: "100%" }}
          >
            {fileName && (fileUpload || getImage) && (
              <a
                href={fileName}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "underline", fontSize: "18px" }}
              >
                View
              </a>
            )}
          </Grid>

          {selectedTableData?.length > 0 && (
            <Grid item xs={12} sm={12} md={12}>
              <ColumnGroupingTable
                columns={tableColumns}
                rows={selectedTableData}
              />
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {status === loanApplicationStatus?.inProcess ||
            status === loanApplicationStatus?.aadhaar ||
            status === loanApplicationStatus?.selfie ? (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ textAlign: "end" }}
              >
                <Button
                  size="small"
                  className={classes.nextButton1}
                  onClick={() => handlecanceluser()}
                >
                  Back
                </Button>
                <Button
                  size="small"
                  disabled={callInProgress || disableNext}
                  className={classes.nextButton}
                  onClick={(event) => handlecreateuserSubmit(event)}
                >
                  {enabledV2InprocessTab ? "Submit" : "Next"}
                </Button>
              </Grid>
            ) : (
              <Grid item xs={12} sm={12} md={12} style={{ textAlign: "end" }}>
                <Button
                  size="small"
                  className={classes.nextButton1}
                  diabled={callInProgress}
                  onClick={() => back()}
                >
                  Back
                </Button>
                <Button
                  size="small"
                  diabled={callInProgress}
                  className={classes.nextButton}
                  onClick={() => handlenext()}
                >
                  Next
                </Button>
              </Grid>
            )}
          </Grid>
          {callInProgress && (
            <CircularProgresss callInProgress={callInProgress} />
          )}
          {toast && (
            <ToastModal
              toastMessage={toastMessage}
              toastMessageType={toastMessageType}
              toastUpdate={toastUpdate}
            />
          )}
          {confirmationModal && (
            <ConfirmationModal
              confirmationModal={confirmationModal}
              confirmationModalHeader={confirmationModalHeader}
              confirmationModalMsg={confirmationModalMsg}
              handleNegativeButton={handleNegativeResponse}
              handlePositiveButton={handlePositiveResponse}
              classes={classes}
            />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

Nominee.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  loanApplicationNumber: PropTypes.object,
  editable: PropTypes.object,
};

export default Nominee;